import { render } from "./MainPhoto.vue?vue&type=template&id=359c0cdf&scoped=true&ts=true"
import script from "./MainPhoto.vue?vue&type=script&lang=ts"
export * from "./MainPhoto.vue?vue&type=script&lang=ts"

import "./MainPhoto.vue?vue&type=style&index=0&id=359c0cdf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359c0cdf"]])

export default __exports__